var host = "https://api-v2.createquickcv.com/api";
// var host = "https://api-staging-quickcv.bitflex.xyz/api";

const { h } = require("vue");

module.exports = {
    V1API: {
        // QuickCV
        'getAccessToken': host + '/authentication/token/admin',
        'refreshAccessToken': host + '/authentication/token/refresh',
        'verifyLogin': host + '/authentication/token/verify',

        // Dashboard
        'get_dashboard_count': host + '/dashboard/count',
        'get_feature_frequency': host + '/dashboard/feature-usage-statistics',
        'get_activity_frequency': host + '/dashboard/activity-action-statistics',
        'get_user_type_graph': host + '/dashboard/select-id-statistics',

        // API Key
        'get_key': host + '/settings/site/view',
        'create_key': host + '/settings/site/update',

        // Prompt Category
        'prompt_category_list': host + '/prompt/categories',
        'create_prompt_category': host + '/prompt/categories/create',
        'update_prompt_category': host + '/prompt/categories/update/',
        'prompt_category_delete': host + '/prompt/categories/delete/',

        // Prompt Template
        'prompt_template_list': host + '/prompt/templates',
        'create_prompt_template': host + '/prompt/templates/create',
        'update_prompt_template': host + '/prompt/templates/update/',
        'prompt_template_delete': host + '/prompt/templates/delete/',
        'prompt_template_toggle': host + '/prompt/templates/toggle/',

        // Sidebar Menu
        'update_sidebar_toggle': host + '/sidebar/toggle/',
        'sidebar_list': host + '/sidebar/',
        'main_toggle_value': host + '/settings/site/view',
        'update_main_toggle': host + '/settings/site/sidebar/toggle',

        // Course
        'course_category_list': host + '/courses/category/',
        'course_category_parent': host + '/courses/category/parent',
        'course_category_list_by_parent': host + '/courses/sub-category/by-category/',
        'create_course_category': host + '/courses/category/create',
        'update_course_category': host + '/courses/category/update/',
        'course_category_delete': host + '/courses/category/delete/',
        'course_list': host + '/courses/',
        'create_course': host + '/courses/create',
        'course_detail': host + '/courses/detail/',
        'update_course': host + '/courses/update/',
        'course_delete': host + '/courses/delete/',
        'voucher_user_list': host + '/courses/user/coupon/list',

        // Course Partner
        'partner_list': host + '/courses/partner',
        'create_partner': host + '/courses/partner/create',
        'update_partner': host + '/courses/partner/edit/',
        'partner_delete': host + '/courses/partner/delete/',

        // E-Book
        'e_book_list': host + '/ebook/admin/list',
        'create_e_book': host + '/ebook/create',
        'update_e_book': host + '/ebook/update/',
        'e_book_delete': host + '/ebook/delete/',

        // Feedback
        'feedback_list': host + '/feedback/list',
        'feedback_delete': host + '/feedback/delete/',

        // Package
        'package_list': host + '/subscription/admin-site/pack/admin-list',
        'create_package': host + '/subscription/pack/create',
        'update_package': host + '/subscription/pack/edit/',
        // 'package_delete': host + '/subscription/pack/delete/',

        // Coupon
        'coupon_list': host + '/coupons/',
        'create_coupon': host + '/coupons/create',
        'update_coupon': host + '/coupons/update/',
        'coupon_delete': host + '/coupons/delete/', 

        // Affiliate Referral
        'referral_user_list': host + '/referral/affiliate-referral/usage/list',
        'referral_list': host + '/referral/affiliate-referral/list',
        'create_referral': host + '/referral/affiliate-referral/create',
        'update_referral': host + '/referral/affiliate-referral/update/',
        'update_referral_toggle': host + '/referral/affiliate-referral/toggle/',
        'referral_delete': host + '/referral/affiliate-referral/delete/',

        // Coin
        'coin_list': host + '/coin-wallet/feature-costs/dash',
        'create_coin': host + '/coin-wallet/feature-costs/create',
        'update_coin': host + '/coin-wallet/feature-costs/edit/',
        'coin_delete': host + '/coin-wallet/feature-costs/delete/',

        // Subscriber
        'subscriber_list': host + '/dashboard/regular-premium/list',
        'payment_initiated_list': host + '/dashboard/unpaid/list',
        'expiring_soon_list': host + '/dashboard/expiring-subscription/list',
        'activated_list': host + '/dashboard/paid-active/list',
        'subscriber_history': host + '/dashboard/user/wallet-history',
        'subscriber_delete': host + '/authentication/delete/',
        'toggle_test_profile': host + '/profile/test-profile/toggle/',
        'activity_history': host + '/activity-logs/list-user/',
        'user_route_log': host + '/activity-logs/route-log/log-list',

        // Payment Log
        'payment_log_list': host + '/dashboard/payment-log/list',
        'payment_details': host + '/location/shelter/details/',
        'create_payment': host + '/location/shelter/create',
        'update_payment': host + '/location/shelter/edit/',
        'payment_delete': host + '/location/shelter/delete/',

        // Payment Debug
        'verify_payment': host + '/payment/pgw/debug',
        'fix_payment': host + '/payment/pgw/fix',

        // Label
        'label_list': host + '/jd-tracking/dashboard/label-list',
        'create_label': host + '/jd-tracking/dashboard/label-create',
        'update_label': host + '/jd-tracking/dashboard/label-update/',
        'label_delete': host + '/jd-tracking/dashboard/label-delete/',

        // Language
        'language_list': host + '/additional-qualification/languages/list',
        'create_language': host + '/additional-qualification/languages/add',
        'update_language': host + '/additional-qualification/languages/update/',
        'language_delete': host + '/additional-qualification/languages/delete/',

        // Digital Skill
        'skill_list': host + '/additional-qualification/skills/list',
        'create_skill': host + '/additional-qualification/skills/add',
        'update_skill': host + '/additional-qualification/skills/update/',
        'skill_delete': host + '/additional-qualification/skills/delete/',
    }
};
